import { render, staticRenderFns } from "./news.vue?vue&type=template&id=c3bff294"
import script from "./news.vue?vue&type=script&lang=ts"
export * from "./news.vue?vue&type=script&lang=ts"
import style0 from "./news.vue?vue&type=style&index=0&id=c3bff294&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports